import { decryptData } from '@jumbo/utils/ecryption';
import axios from 'axios';

export const url = process.env.REACT_APP_API_BASE_URL;

// Helper function to get cookie value
const getCookieValue = (name) => {
  const nameEQ = name + '=';
  const cookies = document.cookie.split(';');
  for (let i = 0; i < cookies.length; i++) {
    let cookie = cookies[i].trim();
    if (cookie.indexOf(nameEQ) === 0) {
      return cookie.substring(nameEQ.length);
    }
  }
  return null;
};

const axiosUtil = {
  initalise: (store) => {
    axios.defaults.baseURL = url;
    axios.defaults.withCredentials = true;

    axios.interceptors.request.use(
      (axiosConfig) => {
        axiosConfig.headers['strict-transport-security'] = 'max-age=63072000; includeSubdomains; preload';
        axiosConfig.headers['content-security-policy'] =
          "default-src 'none'; img-src 'self'; script-src 'self'; style-src 'self'; object-src 'none'";
        axiosConfig.headers['x-content-type-options'] = 'nosniff';
        axiosConfig.headers['x-frame-options'] = 'DENY';
        axiosConfig.headers['x-xss-protection'] = '1; mode=block';
        axiosConfig.headers['Content-Type'] = 'application/json';

        // Get token from cookies and set Authorization header
        const token = getCookieValue('access_token');
        if (token) {
          axiosConfig.headers['Authorization'] = `Bearer ${token}`;
        }
        return axiosConfig;
      },
      (error) => {
        Promise.reject(error);
      },
    );

    axios.interceptors.response.use(
      (response) => {
        if (response.data && response.data.encrypted && response.data.data) {
          try {
            const decryptedData = decryptData(response.data.data);
            response.data = decryptedData;
          } catch (error) {
            console.error('Failed to decrypt response:', error);
            return response;
          }
        }
        return response;
      },
      function (error) {
        if (error?.response?.data && error.response.data.encrypted && error.response.data.data) {
          try {
            const decryptedData = decryptData(error.response.data.data);
            error.response.data = decryptedData;
          } catch (decryptError) {
            console.error('Failed to decrypt error response:', decryptError);
          }
        }
        return Promise.reject(error.response);
      },
    );
  },
};

export default axiosUtil;
